/**
 * Pravidla rybolovu — hash route #pravidla-rybolov.
 * Stručná zestručněná verze pro provoz sportovního areálu Sobáčov.
 */

export function RulesFishing() {
  return (
    <section className="bg-gradient-to-b from-white to-steel-50/40 py-12 md:py-20">
      <div className="container-x max-w-3xl">
        <div>
          <div className="text-[10px] uppercase tracking-[0.30em] text-brand-500 font-bold flex items-center gap-2">
            <span className="inline-block w-8 h-px bg-brand-500" />
            Sobáčov · Fishing & Sport Resort
          </div>
          <h1 className="h-display text-4xl md:text-5xl mt-3">Pravidla rybolovu</h1>
          <p className="text-ink-700 mt-3 text-sm">
            Soukromý rybník 3 ha · platné pro sezónu 2026
          </p>
        </div>

        <div className="mt-10 space-y-6">
          <Rule num="1" title="Povolenka a provoz">
            <p>Lov je možný <b>jen s platnou povolenkou</b>. Vystavujeme ji na místě — nelze rezervovat předem.</p>
            <p className="mt-2">Lovná místa jsou přístupná <b>denně 7:00–19:00</b>, noční lov (od 19:00 do 7:00) je možný po předchozí domluvě a se samostatnou povolenkou.</p>
            <p className="mt-2 text-[12px] text-ink-700/80">Lov bez povolenky = okamžité vykázání z areálu a pokuta <b>3 000 Kč</b> za každý započatý den.</p>
          </Rule>

          <Rule num="2" title="Lovná místa">
            <p>K dispozici je <b>6 očíslovaných stanovišť</b> po obvodu rybníka. U každého z nich má rybář vlastní břeh.</p>
            <p className="mt-2">Hosté ubytovaní v rybářských chatkách lov svého stanoviště začínají <b>od 16:00</b> v den příjezdu a končí nejpozději <b>14:00</b> v den odjezdu.</p>
          </Rule>

          <Rule num="3" title="Povolené nářadí" accent="forest">
            <ul className="space-y-1.5 text-ink-800 list-disc list-inside marker:text-forest-600">
              <li>Maximálně <b>2 pruty</b> na rybáře, vždy s průběžnou montáží.</li>
              <li>Minimální průměr hlavního vlasce <b>0,25 mm</b>.</li>
              <li>Zakrmovací loďka <b>povolena</b>.</li>
              <li><b>Zákaz</b> pletených šňůr na hlavním vlasci a šokových materiálů.</li>
              <li>Pruty rybník nepronajímá.</li>
            </ul>
          </Rule>

          <Rule num="4" title="Manipulace s rybou — povinné vybavení" accent="forest">
            <p>Každý rybář mít musí u sebe:</p>
            <ul className="mt-2 space-y-1.5 text-ink-800 list-disc list-inside marker:text-forest-600">
              <li><b>Vanička</b> min. 100 × 50 cm s 20 cm bočnicí a pouštěcí vak.</li>
              <li><b>Podběrák</b> s rozpětím min. 75 cm.</li>
              <li><b>Dezinfekce</b>.</li>
            </ul>
            <p className="mt-2 text-[12px] text-ink-700/80">Rybu manipulujeme co nejníže nad vaničkou nebo nad podběrákem (max. 20–30 cm), nikdy ne na suchém břehu.</p>
          </Rule>

          <Rule num="5" title="Úlovky · chyť a pusť">
            <p>Rybník provozujeme režimem <b>chyť a pusť</b>. Po dezinfekci a zaznamenání rybu šetrně vracíme.</p>
            <ul className="mt-2 space-y-1.5 text-ink-800 list-disc list-inside marker:text-brand-500">
              <li><b>Cejn</b> — bez omezení, dle uvážení rybáře.</li>
              <li><b>Kapr, jeseter, candát, amur, koi kapr</b> — vždy vrátit po dezinfekci.</li>
            </ul>
          </Rule>

          <Rule num="6" title="Chování a hygiena">
            <ul className="space-y-1.5 text-ink-800 list-disc list-inside marker:text-brand-500">
              <li>Stanoviště udržujeme čisté, odpadky odnášíme do kontejneru u recepce.</li>
              <li>Hlasité chování a hudba <b>jen do 22:00</b>; po této době ticho — areál sdílíme s rodinami v chatkách.</li>
              <li>Areál v CHKO Litovelské Pomoraví — nekuřácký u vody, bez ohně mimo vyhrazená místa.</li>
              <li>Děti do 12 let pouze v doprovodu dospělé osoby.</li>
            </ul>
          </Rule>

          <Rule num="7" title="Sankce a vykázání">
            <p>Hrubé porušení pravidel (lov bez povolenky, ponechání chráněné ryby, znečištění areálu, agresivní chování) znamená:</p>
            <ul className="mt-2 space-y-1.5 text-ink-800 list-disc list-inside marker:text-brand-500">
              <li><b>Okamžité vykázání</b> z areálu bez náhrady povolenky či ubytování.</li>
              <li>Pokuta až <b>3 000 Kč</b>.</li>
              <li>Při opakovaném porušení doživotní zákaz vstupu.</li>
            </ul>
          </Rule>
        </div>

        {/* Kontakt blok */}
        <div className="mt-12 bg-gradient-to-br from-steel-800 to-steel-600 text-white p-6 md:p-8 relative overflow-hidden">
          <div className="absolute left-0 top-0 bottom-0 w-1 bg-gradient-to-b from-brand-500 to-brand-700" />
          <div className="absolute right-0 -bottom-16 -mr-16 w-48 h-48 rounded-full bg-brand-500/15 blur-2xl" />
          <div className="relative">
            <div className="text-[10px] uppercase tracking-[0.30em] text-brand-300 font-bold flex items-center gap-2">
              <span className="inline-block w-6 h-px bg-brand-400" />
              Kontakt
            </div>
            <h2 className="text-xl md:text-2xl font-bold tracking-tight mt-2">
              Sobáčov 111 · <span className="font-bold">783 21 Mladeč</span>
            </h2>
            <div className="mt-3 flex flex-wrap gap-3 text-sm">
              <a href="tel:+420775140705" className="bg-brand-500 hover:bg-brand-600 text-white px-4 py-2.5 font-bold uppercase tracking-[0.10em] text-[11px] shadow-lg shadow-brand-700/30 hover:shadow-brand-700/50 transition-shadow">
                +420 775 140 705
              </a>
              <a href="mailto:rezervace.sobacov@gmail.com" className="border border-white/40 hover:bg-white hover:text-ink-900 text-white px-4 py-2.5 font-bold uppercase tracking-[0.10em] text-[11px] transition-colors">
                rezervace.sobacov@gmail.com
              </a>
            </div>
          </div>
        </div>

        <div className="text-center mt-8">
          <a href="#" className="text-ink-700 text-xs uppercase tracking-[0.10em] font-semibold hover:text-brand-500 transition-colors">
            ← Zpět na úvod
          </a>
        </div>
      </div>
    </section>
  )
}

function Rule({
  num, title, children, accent = 'brand',
}: {
  num: string
  title: string
  children: React.ReactNode
  accent?: 'brand' | 'forest'
}) {
  const ring = accent === 'forest' ? 'from-forest-50 to-white border-forest-200' : 'from-white to-brand-50/30 border-ink-900/10'
  const badge = accent === 'forest' ? 'bg-forest-600 text-white' : 'bg-brand-500 text-white'
  return (
    <div className={`relative bg-gradient-to-br ${ring} border p-5 md:p-6 shadow-sm hover:shadow-md transition-shadow`}>
      <div className="flex items-start gap-4">
        <div className={`shrink-0 w-9 h-9 ${badge} grid place-items-center font-bold text-sm shadow`}>
          {num}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-bold text-ink-900 text-lg leading-tight">{title}</h3>
          <div className="mt-2 text-ink-800 text-sm leading-relaxed">{children}</div>
        </div>
      </div>
    </div>
  )
}
